module.exports = __webpack_public_path__ + "images/_/javascripts/components/modal/guidance_slider_modal/images/fifth_327210ae63835b94d9195cac403482e1.png";